import PropTypes from 'prop-types';
import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { layoutTypes } from "./constants/layout";
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
// fakeBackend();

const getLayout = (layoutType) => {
  let Layout = HorizontalLayout;
  switch (layoutType) {
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {

  const { layoutType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
  }));

  const Layout = getLayout(layoutType);

  return (
    <React.Fragment>
      <ToastContainer position="top-center" autoClose={3000} />
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Layout>{route.component}</Layout> // Render without Authmiddleware
            }
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;




// import PropTypes from 'prop-types';
// import React from "react";
// import { useSelector } from "react-redux";
// import { Routes, Route } from "react-router-dom";
// import { layoutTypes } from "./constants/layout";
// // Import Routes all
// import { authProtectedRoutes, publicRoutes } from "./routes";

// // Import all middleware
// import Authmiddleware from "./routes/route";

// // layouts Format
// import VerticalLayout from "./components/VerticalLayout/";
// import HorizontalLayout from "./components/HorizontalLayout/";
// import NonAuthLayout from "./components/NonAuthLayout";

// // Import scss
// import "./assets/scss/theme.scss";

// // Import Firebase Configuration file
// // import { initFirebaseBackend } from "./helpers/firebase_helper";

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// // Activating fake backend
// fakeBackend();

// // const firebaseConfig = {
// //   apiKey: process.env.REACT_APP_APIKEY,
// //   authDomain: process.env.REACT_APP_AUTHDOMAIN,
// //   databaseURL: process.env.REACT_APP_DATABASEURL,
// //   projectId: process.env.REACT_APP_PROJECTID,
// //   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
// //   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
// //   appId: process.env.REACT_APP_APPID,
// //   measurementId: process.env.REACT_APP_MEASUREMENTID,
// // };

// // init firebase backend
// // initFirebaseBackend(firebaseConfig);


// const getLayout = (layoutType) => {
//   let Layout = HorizontalLayout;
//   switch (layoutType) {
//     case layoutTypes.HORIZONTAL:
//       Layout = HorizontalLayout;
//       break;
//     case layoutTypes.HORIZONTAL:
//       Layout = HorizontalLayout;
//       break;
//     default:
//       break;
//   }
//   return Layout;
// };

// const App = () => {

//   const { layoutType } = useSelector((state) => ({
//     layoutType: state.Layout.layoutType,
//   }));

//   const Layout = getLayout(layoutType);

//   return (
//     <React.Fragment>
//       <Routes>
//         {publicRoutes.map((route, idx) => (
//           <Route
//             path={route.path}
//             element={
//               <NonAuthLayout>
//                 {route.component}
//               </NonAuthLayout>
//             }
//             key={idx}
//             exact={true}
//           />
//         ))}

//         {authProtectedRoutes.map((route, idx) => (
//           <Route
//             path={route.path}
//             element={
//               <Authmiddleware>
//                 <Layout>{route.component}</Layout>
//               </Authmiddleware>}
//             key={idx}
//             exact={true}
//           />
//         ))}
//       </Routes>
//     </React.Fragment>
//   );
// };

// App.propTypes = {
//   layout: PropTypes.any
// };

// export default App;